// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentInsVerRequestModel {
    static getAttributeTypeMap() {
        return EnrollmentInsVerRequestModel.attributeTypeMap;
    }
}
EnrollmentInsVerRequestModel.discriminator = undefined;
EnrollmentInsVerRequestModel.additionalProperties = false;
EnrollmentInsVerRequestModel.attributeTypeMap = [
    {
        "name": "insuranceVerification",
        "baseName": "insuranceVerification",
        "type": "EnrollmentInsuranceVerificationModel"
    },
    {
        "name": "survey",
        "baseName": "survey",
        "type": ""
    },
    {
        "name": "demographics",
        "baseName": "demographics",
        "type": "EnrollmentDemographicsModel"
    },
    {
        "name": "clientIdentifiers",
        "baseName": "clientIdentifiers",
        "type": "EnrollmentClientIdentifiersModel"
    },
];
//# sourceMappingURL=enrollmentInsVerRequestModel.js.map